// Copyright (c) 2017 Deere & Company

import PartialDebitInfoPanel from './partial-debit-info-panel';
import actionCreators from '../../action-creators';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claimNumber: state.tcsm.partialDebit.debit.claimNumber,
    claimSubType: state.tcsm.partialDebit.debit.subClaimType,
    claimType: state.tcsm.partialDebit.debit.claimType,
    dealerLocation: buildDealer(state.tcsm.partialDebit.debit.responsibleAccount),
    netAmountPaid: state.tcsm.partialDebit.debit.netAmountPaid,
    pin: state.tcsm.partialDebit.debit.pin
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartialDebitInfoPanel);



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/partial-debit-info-panel/index.js